import Immutable from 'immutable';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import Style from 'components/Toolbar/Shared/Style';
import { projectBrandStyles, projectFlatColors, projectFlatFonts } from 'containers/BrandDefinition/selectors';
import * as Models from 'models';
import { getFontSizeFromBrandStyle } from 'utils/brandStyles';
import styles from './styles.module.scss';

type Props = {
  activeBrandStyleId: string;
  sectionStyles: Models.MasterScreen.SectionStylesMap;
  toggleBrandStyle(style: Models.BrandStyleMap): void;
  dataTestId?: string;
};

const BrandStyle: React.FunctionComponent<Props> = (props) => {
  const {
    activeBrandStyleId,
    toggleBrandStyle,
    sectionStyles,
    dataTestId = 'brandStyle-dropdown',
  } = props;

  const brandStyles = useSelector(projectBrandStyles);
  const colors = useSelector(projectFlatColors);
  const fonts = useSelector(projectFlatFonts);

  const sectionBrandStyles = sectionStyles && sectionStyles.size > 0
    ? sectionStyles.reduce(
      (stylesList, id) => brandStyles.get(id) ? stylesList.push(brandStyles.get(id)) : stylesList,
      Immutable.List<Models.BrandStyleMap>(),
    )
    : brandStyles.toList();

  const getFontSize = _.memoize(getFontSizeFromBrandStyle);
  const sortedSectionBrandStyles = sectionBrandStyles.sort((style1, style2) => {
    return getFontSize(style2) - getFontSize(style1);
  });

  return (
    <Dropdown className={styles.StyleDropdown} dataTestId={dataTestId}>
      <div className={styles.StyleDropdownWrapper}>
        {
          sortedSectionBrandStyles.map((style, index) => {
            const styleId = style?.get('id');

            return (
              <Style
                key={styleId ?? index}
                active={styleId === activeBrandStyleId}
                style={style}
                toggleBrandStyle={toggleBrandStyle}
                colors={colors}
                fonts={fonts}
                dataTestId={`${dataTestId}-style${index}`}
              />
            );
          })
        }
      </div>
    </Dropdown>
  );
};

export default BrandStyle;
